import { FLOW_TYPES } from "../../constants/flowType";
import { useTicketingContext } from "./../../store";
import StepperItem from "./StepperItem";

const Stepper = () => {
  const { state } = useTicketingContext();

  const { steps: stepsText } = state.texts;
  const { active, steps } = state.stepper;

  const isActivitiesOnlyFlow = state.flowType === FLOW_TYPES.ACTIVITIES_ONLY;

  return (
    <ul className={`stepper ${isActivitiesOnlyFlow ? "activities-only" : ""}`}>
      {[...Array(isActivitiesOnlyFlow ? 2 : 3)].map((_, step) => {
        const stepperText = isActivitiesOnlyFlow
        ? stepsText[step + 2]
        : stepsText[step];
        const eventLabel =
        isActivitiesOnlyFlow && step === 0
        ? stepsText[1].event_label
        : undefined;
        const adjustedStep = isActivitiesOnlyFlow ? step + 2 : step;
        return (
          <StepperItem
            activeStep={active}
            isActive={active === parseInt(adjustedStep)}
            key={step}
            stepIndex={parseInt(step)}
            steps={steps}
            title={eventLabel ? eventLabel : stepperText?.stepper_label}
          />
        );
      })}
    </ul>
  );
};

export default Stepper;
